import React, { useState } from 'react';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@material-ui/core';
import { Icon, IconButton } from 'copilot-design-system';

const OptionsMenu = ({ handleClear }: { handleClear: () => void }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton
        icon="Ellipsis"
        label="options"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        variant="minimal"
      />
      <Menu
        open={anchorEl !== null}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        onClose={() => setAnchorEl(null)}
        classes={{
          paper:
            'border border-solid border-secondary-hover shadow-dropdown-menu',
        }}
      >
        <MenuItem
          onClick={() => {
            handleClear();
            setAnchorEl(null);
          }}
        >
          <ListItemIcon classes={{ root: 'min-w-8' }}>
            <Icon icon="Trash" className="w-5 h-5 text-red" />
          </ListItemIcon>
          <ListItemText classes={{ primary: 'text-red' }}>
            Delete address
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default OptionsMenu;
